import { Typography } from '@mui/material';
import { userService } from '@tap/data-providers';
import { useFetchData } from '@tap/mui-ui';

export const ChangeHistoryUserValue = ({ userId }: { userId: number }) => {

    const [userState] = useFetchData(() => userService.getWorkerList({ workerIds: [userId] }), [userId]);

    if (userState.isLoading)
        return (<Typography>...</Typography>);

    if (userState.data)
        return (<Typography>{userService.getUserFIO(userState.data[0])}</Typography>);

    return (<Typography>{userId}</Typography>);
}